module.exports = __webpack_public_path__ + "static/media/mln.70e22075.svg";